module.exports = __webpack_public_path__ + "img/secondopinion_jumbotron.c716d5a1.png";